/**
 * Brand primitives from the Phone UI Figma file, collection Colours (33:1698)
 * and the spacing scale shared by Space and Text Strings.
 * Hex and numbers live only in this module.
 */

export const brandColors = {
  neutrals: {
    baseWhite: '#FBFBFB',
    grey100: '#FAFAFD',
    grey200: '#F3F3F7',
    grey300: '#E8E8EE',
    grey400: '#DAD9E0',
    grey500: '#AAA8B7',
    grey600: '#717180',
    grey700: '#535462',
    grey800: '#434151',
    grey900: '#252637',
    base1000: '#1A1827',
    baseBlack: '#0C0A12',
  },
  primary: {
    yovoRed100: '#FFDEE5',
    yovoRed200: '#FF93AC',
    yovoRed300: '#E9496E',
    yovoRed400: '#CF2048',
    yovoRed500: '#C0042F',
  },
  secondary: {
    secondary100: '#D9E6E9',
    secondary200: '#9EB5BB',
    secondary300: '#5F777E',
    secondary400: '#3A5962',
    secondary500: '#122C34',
  },
  tertiary: {
    tertiary50: '#E4E6F7',
    tertiary200: '#BCBFE3',
    secondary200: '#7D82B8',
    secondary400: '#444B94',
  },
  accents: {
    accents100: '#FFEFE4',
    accents200: '#D7B49E',
    accents300: '#AF734E',
  },
  semantic: {
    red100: '#FFB0B7',
    red200: '#FA5B73',
    red300: '#E22E49',
    red400: '#CE001F',
    green100: '#D6FFDB',
    green200: '#93E19C',
    green300: '#4DAA57',
    green400: '#167620',
    yellow100: '#FFECCB',
    yellow200: '#FFCB6C',
    yellow300: '#FFA400',
    yellow400: '#7A4E00',
  },
};

/** Every raw spacing step. Space stops at 5XL; Text Strings also uses the last four. */
export const brandSpace = {
  none: 0,
  xxs: 2,
  xs: 4,
  s: 6,
  m: 8,
  l: 12,
  xl: 16,
  xxl: 20,
  xxxl: 24,
  xl4: 28,
  xl5: 32,
  smallGaps: 36,
  gaps: 40,
  largeGaps: 48,
  curve: 100,
};
